const csReviewToastMsg = {
  /**
   *  [상품 후기 리스트] 상품 후기 리스트 요청하기
   */
  GET_REVIEW_LIST_REQUEST_SUCCESS: '상품 후기 리스트 요청하기 성공',
  GET_REVIEW_LIST_REQUEST_ERROR: '상품 후기 리스트 요청하기 실패',

  /**
   *  [상품 후기 리스트] 상품 후기 리스트 엑셀 다운로드 요청하기
   */
  GET_REVIEW_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '상품 후기 리스트 엑셀 다운로드 요청하기 성공',
  GET_REVIEW_EXCEL_DOWNLOAD_REQUEST_ERROR: '상품 후기 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [상품 후기 리스트] 태그 리스트 요청하기
   */
  GET_REVIEW_TAG_COLUMN_TAG_LIST_REQUEST_SUCCESS: '상품 후기 태그 리스트 요청하기 성공',
  GET_REVIEW_TAG_COLUMN_TAG_LIST_REQUEST_ERROR: '상품 후기 태그 리스트 요청하기 실패',

  /**
   *  [상품 후기 상세] 상품 후기 상세 요청하기
   */
  GET_REVIEW_DETAIL_REQUEST_SUCCESS: '상품 후기 상세 요청하기 성공',
  GET_REVIEW_DETAIL_REQUEST_ERROR: '상품 후기 상세 요청하기 실패',

  /**
   *  [상품 후기 상세] 상품 후기 상태 변경 요청하기
   */
  CHANGE_REVIEW_STATUS_REQUEST_SUCCESS: '상품 후기 상태 변경 요청하기 성공',
  CHANGE_REVIEW_STATUS_REQUEST_ERROR: '상품 후기 상태 변경 요청하기 실패',

  /**
   *  [상품 후기 상세] 태그 리스트 요청하기
   */
  GET_REVIEW_TAG_LIST_REQUEST_ERROR: '태그 리스트 요청하기 실패',
  GET_REVIEW_TAG_LIST_REQUEST_SUCCESS: '태그 리스트 요청하기 성공',
  /**
   *  [상품 후기 상세] 전체 태그 리스트 엑셀 다운로드
   */
  GET_REVIEW_DETAIL_TAG_ALL_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '전체 태그 리스트 엑셀 다운로드 요청하기 성공',
  GET_REVIEW_DETAIL_TAG_ALL_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '전체 태그 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [상품 후기 상세] 선택 태그 리스트 엑셀 다운로드
   */
  GET_REVIEW_DETAIL_TAG_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '선택 태그 리스트 엑셀 다운로드 요청하기 성공',
  GET_REVIEW_DETAIL_TAG_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '선택 태그 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [상품 후기 상세] 선택된 태그 리스트 엑셀 업로드
   */
  SET_REVIEW_DETAIL_TAG_EXCEL_UPLOAD_REQUEST_SUCCESS: '엑셀 업로드 요청하기 성공',
  SET_REVIEW_DETAIL_TAG_EXCEL_UPLOAD_REQUEST_ERROR: '엑셀 업로드 요청하기 실패',

  /**
   *  [상품 후기 상세] 상품 후기 편집 요청하기
   */
  EDIT_REVIEW_REQUEST_SUCCESS: '상품 후기 편집 요청하기 성공',
  EDIT_REVIEW_REQUEST_ERROR: '상품 후기 편집 요청하기 실패',

  /**
   *  [상품 후기 등록] 상품 후기 등록하기 전 필요한 데이터 요청하기
   */
  PREPARE_INSERT_REVIEW_REQUEST_SUCCESS: '상품 후기 등록하기 전 필요한 데이터 요청하기 성공',
  PREPARE_INSERT_REVIEW_REQUEST_ERROR: '상품 후기 등록하기 전 필요한 데이터 요청하기 실패',

  /**
   *  [상품 후기 등록] 상품 리스트 데이터 요청하기
   */
  GET_PRODUCT_LIST_REQUEST_ERROR: '상품 리스트 데이터 요청하기 싪패',

  /**
   *  [상품 후기 등록] 구매자 리스트 데이터 요청하기
   */
  GET_USER_LIST_REQUEST_ERROR: '구매자 리스트 데이터 요청하기 실패',

  /**
   *  [상품 후기 등록] 상품의 연결된 태그 리스트 데이터 요청하기
   */
  GET_PRODUCT_TAG_LIST_REQUEST_SUCCESS: '상품의 연결된 태그 리스트 데이터 요청하기 성공',
  GET_PRODUCT_TAG_LIST_REQUEST_ERROR: '상품의 연결된 태그 리스트 데이터 요청하기 실패',

  /**
   * [상품 후기 등록] 상품 후기 등록하기
   */
  CREATE_REVIEW_REQUEST_SUCCESS: '상품 후기 등록하기 성공',
  CREATE_REVIEW_REQUEST_ERROR: '상품 후기 등록하기 실패',
};

export default csReviewToastMsg;
